export const FIELD_VIEW_URL = {
  'DATA_INBOX': '/static/field-view/#/data-inbox/',
  'OPERATIONAL_TABLE_VIEW': '/static/field-view/#/script-creator',
  'FIELD_SELECTION': '/static/field-view/#/field-selection-web',
  'SCRIPT_CREATOR': '/static/field-view/#/variable-rate',
} as const;

export const SCRIPT_CREATOR_URL = {
  // TODO: Update the route to match Bulk Prescription Creation route on ticket https://climate.jira.com/browse/SCR-1598
  'BULK_PRESCRIPTIONS': '/static/field-view/#/variable-rate/bulk-create',
  'FIELD_LEVEL_SEED_RECS': '/static/field-view/#/variable-rate/recommendations'
} as const;
